import React, { useState } from "react";
import { Badge, Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { AddIcon, EditIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import * as routesNames from '../../../../../constant/routes'
import CustomTable, {Column,} from "../../../../../components/customTable/CustomTable";
import { Team } from "../../ServiceTeamManagement/modal";
import { AlertCard, CustomToast } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";


interface Props {
  teamData: Team[];
  handleEdit: (team: Team) => void;
  getTeamList: () => Promise<void>;
  loading: boolean
}

const ServiceTeamManagementList: React.FC<Props> = ({ teamData, handleEdit,getTeamList,loading }) => { 
  const navigate = useNavigate();
  const { fetchApi } = useFetch();
  const { addToast } = CustomToast();
   const [selectedTeam, setSelectedTeam] =useState<Team | null>(null); 
  const [statusAlertOpen, setStatusAlertOpen] = useState(false);
  const handleAddMember = (team: Team) => {
    navigate(routesNames.SERVICEADDMEMBER, {
      state: {
        selectedTeam: team,
        allTeams: teamData,
      },
    });
  };

  const handleStatusClick = (team: Team) => {
    setSelectedTeam(team);
    setStatusAlertOpen(true);
  };

   const handleChangeStatus = async () => {
    if (!selectedTeam) return;
    const body = { serviceTeamId: selectedTeam.teamId,status: !selectedTeam.status,};
    const response = await fetchApi("ServiceTeamMast/changeStatus", "PUT",body, null,`Team ${ !selectedTeam.status ? "Activated" : "Deactivated" } Successfully`
    );
    if (response?.success) {
      setStatusAlertOpen(false);
      setSelectedTeam(null);
      getTeamList();
    }
  };


  return (
    <>
      <Box>
        <CustomTable value={teamData} emptyMessage="No Team Added" pagination={false} loading={loading}>
          <Column
            header="S.No"
            body={(_, index) => index + 1}
          />

          <Column
            header="Team Name"
            field="teamName"
            body={(row: Team) => <Text>{row.teamName}</Text>}
          />

          <Column
            header="Service Interested In"
            field="serviceName"
            body={(row: Team) => <Text>{row.serviceName || row.serviceInterestedName || "-"}</Text>}
          />

          <Column
            header="Team Lead"
            field="teamLead"
            body={(row: Team) => <Text>{row.teamLead}</Text>}
          />

           <Column
            header="Created By"
            field="createdBy"
            body={(row: Team) => <Text>{row.createdBy}</Text>}
          />

        <Column
          header="Status"
          body={(row: Team) => (
            <span            
              style={{ cursor: "pointer" }}
               onClick={() =>
                  handleStatusClick(row)
                }
            >
              {row.status ? (
                <Badge colorScheme="green" px={2} py={1} borderRadius={4}>
                  Active
                </Badge>
              ) : (
                <Badge colorScheme="red" px={2} py={1} borderRadius={4}>
                  Inactive
                </Badge>
              )}
            </span>
          )}
        />
          <Column
            header="Action"
            body={(row: Team) => (
              <Flex align="center" gap={3}>
                <Tooltip label="Edit Team" placement="bottom" hasArrow>
                  <Box cursor="pointer">
                    <EditIcon onClick={() => handleEdit(row)} />
                  </Box>
                </Tooltip>

                <Tooltip label="Add Member" placement="bottom" hasArrow>
                  <Box cursor="pointer">
                    <AddIcon
                      boxSize="12px"
                      onClick={() => handleAddMember(row)}
                    />
                  </Box>
                </Tooltip>
              </Flex>
            )}
          />
        </CustomTable>
        
      </Box>
       <AlertCard isOpen={statusAlertOpen} onClose={() => setStatusAlertOpen(false) } onConfirm={handleChangeStatus} 
        title={`${ selectedTeam?.status ? "Deactivate" : "Activate" } Team`} description={`Are you sure you want to ${ 
          selectedTeam?.status ? "deactivate" : "activate" } this team?`} confirmLabel="Confirm"
        cancelLabel="Cancel" colorScheme={ selectedTeam?.status ? "red" : "green" }
      />
    </>
  );
};

export default ServiceTeamManagementList;